import {Avatar} from 'antd'
import {organization_getOrganizationsByUser_Api} from 'apis'
import {FollowButton} from 'components/Feed/FollowButton'
import getAvatar from 'helpers/getAvatar'
import {LazyPagination} from 'modules/asyncCache/components/LazyPagination'
import Translate from 'modules/local/Translate'
import React, {useMemo} from 'react'
import {BiSolidChurch} from 'react-icons/bi'
import {renderLoading} from 'views/AppLocals/functions/renderers/renderLoading'
import {bindQueryParam} from 'views/AppLocals/functions/routerHelper'
import getTitle from "../../../../helpers/getTitle";
import {Link} from "react-router-dom";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import {OrgType} from "../../Organization/components/OrgType";
import useTranslate from "../../../../modules/local/useTranslate";


const renderItem = (item, index) => {
  return (
      <Translate key={index}>
        {(t) => (
            <div className="w-full py-2 flex flex-col gap-2 custom-item-render custom-render-border relative">
              <div className="flex items-start gap-2">
                <Avatar
                    size={36}
                    icon={
                      <BiSolidChurch size={16} className="text-primary-600"/>
                    }
                    src={getAvatar(item)}
                    className="flex flex-center bg-primary-50 rounded-md flex-shrink-0"
                />
                <div className="flex flex-col flex-1 min-w-0">
                  <Link to={getLinkToDetail(item)} className="font-bold text-sm text-color-000 no-underline leading-snug truncate">
                    {getTitle(item)}
                  </Link>
                  <OrgType item={item} className="font-medium text-2xs text-blue-500 italic leading-tight"/>
                </div>
              </div>
              <div className="flex justify-end">
                <FollowButton
                    size="medium"
                    item={item}
                />
              </div>
            </div>
        )}
      </Translate>
  )
}
const UserOrganizations = ({ sample = 10, user_id, ...props }) => {
  const t = useTranslate()
  const apiInfo = organization_getOrganizationsByUser_Api
  const refreshKey = useMemo(
    () => [apiInfo.path.replace(':id', user_id)].join('/'),
    [user_id]
  )

  return (
      <LazyPagination
          sample={sample}
          key={refreshKey}
          apiInfo={apiInfo}
          refreshKey={refreshKey}
          renderLoading={renderLoading}
          renderItem={renderItem}
          query={bindQueryParam({ id: user_id })}
          {...props}
      />
  )
}

export default UserOrganizations
